import { configHelper } from '@ilteducation/config';

export const SOCKET_URL = configHelper.isLocal()
  ? `ws://localhost:3001`
  : `wss://socket.global.${configHelper.environment() === 'production' ? 'prod' : 'staging'}.ilteducation.com/quizter`;

export enum GameState {
  INIT,
  READY,
  SETTINGS,
  LOBBY,
  SHOW_QUESTION_PHRASE,
  SHOW_QUESTIONS,
  SHOW_CORRECT_ANSWER,
  SHOW_RESULTS,
  GAME_NOT_FOUND,
  PLAYER_CANNOT_JOIN,
  UNHANDLED_ERROR,
  // Appended, not inserted: these values are persisted in session storage.
  LOGIN_REQUIRED,
  SESSION_SUPERSEDED,
}

// A successful join contradicts all of these, and GameState is persisted, so they have to be cleared
// rather than left to expire.
export const ErrorGameStates = new Set<GameState>([
  GameState.GAME_NOT_FOUND,
  GameState.PLAYER_CANNOT_JOIN,
  GameState.UNHANDLED_ERROR,
  GameState.LOGIN_REQUIRED,
  GameState.SESSION_SUPERSEDED,
]);
